module.exports = __webpack_public_path__ + "static/media/team-image.8ed28a01.png";